import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class PictureService {
    public constructor(private http: HttpClient) {}

    public fetchStaticPictureURLForReplacementProduct(serialnumber: string): Observable<string> {
        return this.http.get(`/api/product/${serialnumber}/picture`, {
            responseType: 'text',
        });
    }
}
